module.exports = __webpack_public_path__ + "img/principle.bfbc4361.svg";